import { Typography as T } from "@mui/material";
import { PageContainer, ContentContainer, HeaderGradient } from "../components";
import ReportingService from "../../../../api/services/ReportingService";

type Props = {};

const Reporting = (props: Props) => {
  const handleGenerateResultsReport = async () => {
    await ReportingService.generateResultsSummaryReport({});
  };
  return (
    <PageContainer>
      <HeaderGradient
        title="Reports"
        subtitle="Review program stats and summary"
      />
      <ContentContainer>
        <div className="flex flex-col">
          <T variant="headingSm">General</T>
          <div className="mt-16">
            <div onClick={() => handleGenerateResultsReport()}>
              <T variant="mdReg" sx={{ cursor: "pointer" }}>
                Program Results Report - Current
              </T>
            </div>
          </div>
        </div>
      </ContentContainer>
    </PageContainer>
  );
};

export default Reporting;
